// Theme string assignment should match folder structure
export enum Themes {
  PF_BRAND = 'pfbrand',
  PF_CHRISTMAS = 'pfchristmas'
}
